module.exports = __webpack_public_path__ + "static/media/hr.635a6093.svg";